
export const mockPromise = (time: number, resolvePromise: boolean): Promise<string>  =>
    new Promise((resolve, reject) => {
        const interval = setInterval(() => {
        clearInterval(interval)
        resolvePromise ? resolve() : reject()
        }, time)
    })

export const preloadImages = async (imageURLs: string[], forceTime: unknown) => {
    const promises = imageURLs.map(url => new Promise((resolve, reject) => {
        const img = new Image()
        img.onerror = reject
        img.onload = resolve
        img.src = url
    }))

    const promisesAll = Promise.all(promises)

    return isNaN(forceTime as number)
    ? promisesAll
    : Promise.race([promisesAll, mockPromise(forceTime as number, true)])
}
